import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { Business, BusinessProps } from './businessTypes';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const syncBusinessPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<BusinessProps>>();
const businessPayloadCreator = getPayloadCreator<Business>();
const businessesPayloadCreator = getPayloadCreator<Business[]>();

export const getBusiness = createAction('GET_BUSINESS', getPayloadCreator());
export const getBusinessSuccess = createAction('GET_BUSINESS_SUCCESS', syncBusinessPayloadCreator);
export const getBusinessFailure = createAction('GET_BUSINESS_FAILURE', errorPayloadCreator);

export const updateBusinessBump = createAction('UPDATE_BUSINESS_BUMP', syncBusinessPayloadCreator);

export const createBusiness = createAction('CREATE_BUSINESS', businessPayloadCreator);
export const createBusinessSuccess = createAction('CREATE_BUSINESS_SUCCESS', businessPayloadCreator);
export const createBusinessFailure = createAction('CREATE_BUSINESS_FAILURE', errorPayloadCreator);

export const updateBusiness = createAction('UPDATE_BUSINESS', businessPayloadCreator);
export const updateBusinessSuccess = createAction('UPDATE_BUSINESS_SUCCESS', businessPayloadCreator);
export const updateBusinessFailure = createAction('UPDATE_BUSINESS_FAILURE', errorPayloadCreator);

export const deleteBusiness = createAction('DELETE_BUSINESS', businessPayloadCreator);
export const deleteBusinessSuccess = createAction('DELETE_BUSINESS_SUCCESS', businessPayloadCreator);
export const deleteBusinessFailure = createAction('DELETE_BUSINESS_FAILURE', errorPayloadCreator);

export const batchUpdateBusinesses = createAction('BATCH_UPDATE_BUSINESSES', businessesPayloadCreator);
export const batchUpdateBusinessesSuccess = createAction('BATCH_UPDATE_BUSINESSES_SUCCESS', businessesPayloadCreator);
export const batchUpdateBusinessesFailure = createAction('BATCH_UPDATE_BUSINESSES_FAILURE', businessesPayloadCreator);
